export enum HttpStatusEnum {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    UNDEFINED = 'UNDEFINED',
}
